'use client';

import { useTranslation } from 'next-i18next';
import { VscLoading as IconLoading } from 'react-icons/vsc';

interface AuthLoadingOverlayProps {
  isActive: boolean;
}

export default function AuthLoadingOverlay({ isActive }: AuthLoadingOverlayProps) {
  const { t } = useTranslation('common');

  if (!isActive) return null;

  return (
    <div className='bg-[var(--np-bg-2)]/95 absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 rounded-2xl backdrop-blur-sm'>
      <IconLoading className='size-8 animate-spin text-[var(--np-green)]' />
      <span className='text-sm font-bold uppercase tracking-[0.08em] text-[var(--np-fg-dim)]'>{t('login.signing_in')}</span>
    </div>
  );
}
